import React, { useState, useEffect } from "react";
import Modal from '@material-ui/core/Modal';
import VerificationContent from "./VerificationModalContent";
import '../styles/verificationModal.css'

export const SpetzModal = ({ openModal, goThanksScreen, phoneNumber, countryID, handleChangeNumber, secondsToWait, serviceCallId }) => {
  const [showModal, setShowModal] = useState(false);
  
  const modalState = (state) => {
    if (state) {
      setShowModal(showModal => !showModal)
    }
  }

  useEffect(() => { 
    const handler = () => { 
      setShowModal(true)
    }
    if (openModal) handler();
  }, [openModal]);

  return (
    <div>
      <Modal
        className="modal"
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={showModal}
        onClose={modalState}
        closeAfterTransition
        hideBackdrop={true}
      >
        <VerificationContent
          modalState={modalState}
          goThanksScreen={goThanksScreen}
          phoneNumber={phoneNumber}
          countryID={countryID}
          handleChangeNumber={handleChangeNumber}
          secondsToWait={secondsToWait}
          serviceCallId={serviceCallId}
        />
      </Modal>
    </div>
  );
}
